module.exports = __webpack_public_path__ + "img/2025-01-09b_3.f9914503.jpg";